export * from './IconPipette';
